// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"a560e51f","125":"a560e51f","129":"a560e51f","411":"a560e51f","756":"a560e51f","930":"a560e51f","941":"a560e51f"}[chunkId] + ".chunk.css";
};